import { useState, useEffect } from 'react';

/**
 * Manages dark-mode state for Oracle Insight.
 * - On first load, reads localStorage ('oi-dark-mode'). If no saved preference,
 *   falls back to the OS/browser prefers-color-scheme setting.
 * - Applies/removes the 'dark' class on <html> whenever the value changes.
 * - Persists the user's choice to localStorage on every toggle.
 */
export function useDarkMode(): { dark: boolean; toggle: () => void } {
  const [dark, setDark] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    const saved = localStorage.getItem('oi-dark-mode');
    if (saved !== null) return saved === 'true';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('oi-dark-mode', String(dark));
  }, [dark]);

  return { dark, toggle: () => setDark(prev => !prev) };
}
